import React, {useCallback} from 'react';
import error from 'assets/images/icons/error.png';
import info from 'assets/images/icons/info.png';
import success from 'assets/images/icons/success.png';
import warning from 'assets/images/icons/warning.png';
import styles from './Toast.module.scss';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

export const Toast = (props) => {
  const {message, type, toastProps} = props;
  const icons = {error, info, success, warning};

  console.log(toastProps.toastId);
  const close = useCallback( () => {
    toastProps.closeToast();
    toastProps.deleteToast();
    toast.dismiss(toastProps.toastId);
  }, [toastProps])

  return (
    <div className={styles.container}>
      <img src={icons[type]} alt="" className={styles.imageContainer}/>
      <span>{message}</span>

      <button className="Toastify__close-button Toastify__close-button--default" type="button" aria-label="close" onClick={close}>
        <svg aria-hidden="true" viewBox="0 0 14 16">
          <path fillRule="evenodd"
                d="M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"></path>
        </svg>
      </button>
    </div>
  );
};

Toast.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  closeToast: PropTypes.func
}

Toast.defaultProps = {}

export default Toast;
